import { tabbable } from "tabbable"

/**
 * Finds all focusable elements in the target element and returns the first, last and total focusable elements
 *
 * @param {Object} element - element in which you need to find focusable elements
 * @returns {Object}
 */
const firstAndlastFocusEls = (element) => {
  const focusEls = tabbable(element)

  const total = focusEls.length
  return {
    firstEl: focusEls[0],
    lastEl: focusEls[total - 1],
    total,
  }
}

/**
 * Implements focus trap inside an element
 *
 * @param {Object} element element in which focus trap needs to be implemented
 * @param {Object} event React.syntheticEvent
 */
export const focusTrap = (element, event) => {
  const { firstEl, lastEl } = firstAndlastFocusEls(element)

  /**
   * if `shift` key is pressed
   * and the activeElement is first focusable element
   * loop to the last foccussable element and set focus to it
   */
  if (event.shiftKey && document.activeElement === firstEl) {
    lastEl.focus()
    event.preventDefault()
  }

  if (!event.shiftKey && document.activeElement === lastEl) {
    /**
     * if the activeElement is the last focusable element
     * loop to the first focusable element and set focus to it
     */
    firstEl.focus()
    event.preventDefault()
  }
}
